<div>
<div class="row backg search-container">
  <div class="container">
    <div class="row search-div d-flex flex-row align-content-around">
      <div class="col-12">
        <h2
          class="text-center"
          i18n="Titolo Cerca un farmaco|Pagina ricerca, form @@search-page.search-bar.title"
        >
          Cerca un farmaco
        </h2>
        <app-search-input
          [suggestion]="true"
          (queryEvent)="search($event)"
        ></app-search-input>
      </div>
    </div>
  </div>
</div>

<div class="row bg-primary">
  <div class="col-12">
    <div class="container">
      <div class="d-flex justify-content-around">
        <!--START COMPONENTE STAT ITEM-->
        <div class="d-flex flex-wrap justify-content-center mb-3 mt-3">
          <div
            *ngFor="let item of statData$ | async; index as i"
            class="d-flex flex-row"
          >
            <app-stats-item
              [iconName]="item.iconName"
              [authorizedValue]="item.authorizedValue"
              [title]="item.title"
              [onTheMarketValue]="item.onTheMarketValue"
              [link]="item.link"
            ></app-stats-item>
          </div>
        </div>
        <!--END COMPONENTE STAT ITEM-->
      </div>
      <h6 class="align-text" i18n="Titolo Cerca un farmaco|Pagina ricerca, form @@search-page.stats-item.sub-text">(*) immissione in commercio di almeno una confezione autorizzata</h6>
    </div>
  </div>
</div>

<div class="row">
  <app-button-section></app-button-section>
</div>

<div class="row" *ngIf="(topTenData$ | async)">
  <app-topten [data]="topTenData$ | async"></app-topten>
</div>
</div>